module.exports = __webpack_public_path__ + "img/BCE-HERO.fa5f522f.jpg";